export enum AttachmentType {
  PHOTO,
  FILE,
}
